module.exports = __webpack_public_path__ + "static/img/ARAS450_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/ARAS450_1.png
// module id = PLTV
// module chunks = 0